import styled from 'styled-components';
import { Overlay } from 'ui/overlay';
import { Spinner } from 'ui/spinner';
import { LogoColors } from 'ui/logo';

const StyledOverlay = styled(Overlay)`
  position: absolute;
`;

export const LoadingOverlay = ({ ...props }) => {
  return (
    <StyledOverlay zIndex={null} {...props}>
      <Spinner color={LogoColors.WHITE} />
    </StyledOverlay>
  );
};
